import { NgModule } from '@angular/core';
import { MealSuggestionsPage } from 'pages/meal-suggestions/meal-suggestions';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [MealSuggestionsPage],
    imports: [PagesModule, ComponentsModule]
})
export class MealSuggestionsPageModule {}
